import React from "react";
import { FormHandles, FormProps } from "@unform/core";
import { Form as UnformForm } from "@unform/web";

type Props = Omit<FormProps, "ref"> & React.RefAttributes<FormHandles>;

const Form = UnformForm as unknown as React.ForwardRefExoticComponent<Props>;

export default Form;
